/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 14:49:05
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:02:30
 * @name: 订单列表对象
 * @Description: 订单列表对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\approvalList\orderApproval.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { orderGetList } from "@/api/order/order.api.js";
import { apiMethod } from "@/utils/decorator.js";
const orderApproval = class orderApproval {
  constructor() {
    this.statusList = []; //订单状态
    this.table_order_data = { total: 0, list: [] }; //订单表格
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取审批单状态数组
   */
  async getStatusList() {
    this.statusList = [{ id: "", name: "全部" }, { id: 0, name: "特价审批" }, { id: 1, name: "待付款" }, { id: 10, name: "待付款审核" }, { id: 2, name: "待生产" }, { id: 20, name: "生成中" }, { id: 3, name: "待发货" }, { id: 4, name: "待收货" }, { id: 5, name: "待评价" }, { id: 6, name: "已完成" },];
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取售后审批单表格数据
   * @param {Object} res 回传数据
   */
  @apiMethod(orderGetList)
  async getTableData(res) {
    if (res.code === 200) {
      this.table_order_data.total = res.data.total;
      this.table_order_data.list = res.data.data;
    }
  }
}

export default orderApproval;